import { atom } from 'jotai';

// Module-scoped via Jotai so Strict Mode unmount/remount cannot re-trigger startRecording().
export const handsFreeHasStartedAtom = atom(false);

// Module-scoped via Jotai so Strict Mode unmount/remount cannot re-trigger endRecording() scheduling.
export const handsFreeHasEndedAtom = atom(false);
